import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MixpanelService } from '@core/services';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-sequencing-resources-section',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './sequencing-resources-section.component.html',
    styleUrls: ['./sequencing-resources-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SequencingResourcesSectionComponent {
    constructor(private mixpanelService: MixpanelService) {}

    logLinkClick(eventName: string) {
        this.mixpanelService.logEvent(eventName);
    }
}
